import React, { Component } from 'react';
import {
	Dropdown,
	Form,
	Container,
	Checkbox,
	Input,
	Modal,
	Button,
	Message,
	Dimmer,
	Loader,
	Image
} from 'semantic-ui-react';
import { DatePicker, TimePicker } from '@progress/kendo-react-dateinputs';
import axios from 'axios';
import ReCAPTCHA from 'react-google-recaptcha';
import { format } from 'date-fns';

import '@progress/kendo-theme-bootstrap/dist/all.css';
import config from '../config';
import dropdownOptions from '../dropdownOptions.json';
import VehicleNumberLocation from '../static/vehicleNumberLocation.PNG';

class VRPForm extends Component {
	constructor(props) {
		super(props);
		this.state = this.initialState = {
			vehicleType: '',
			vehicleNumber: '',
			lrvCar: '',
			metrolinkStation: '',
			lrvLocation: '',
			busLocation: '',
			direction: '',
			incidentClassification: '',
			caseNum: '',
			suspectDesc: '',
			synopsis: '',
			mediaType: '',
			mediaQuantity: '',
			agencyName: '',
			officerName: '',
			officerDSN: '',
			contactEmail: '',
			contactPhone: '',
			incidentDt: new Date(),
			incidentTime: new Date(new Date().setMinutes(0)),
			formError: false,
			errorHeader: '',
			errorContent: '',
			formSuccess: false,
			successHeader: '',
			successContent: '',
			noticeAccepted: false,
			reCaptchaResponse: '',
			loading: false
		};
	}

	setStateAsync = (state) => {
		return new Promise((resolve) => {
			this.setState(state, resolve);
		});
	};

	handleSubmit = async (e) => {
		e.preventDefault();

		if (!this.state.noticeAccepted) {
			this.setState({
				formError: true,
				errorHeader: 'Confidentality Notice',
				errorContent:
					'You must agree to have read the confidentiality notice in order to submit your request.'
			});
			window.scrollTo(0, 0);
			return;
		}

		try {
			await this.setStateAsync({ loading: true });

			//* combine the incident date and the incident time.
			let date = this.state.incidentDt;
			let time = this.state.incidentTime;
			date.setHours(time.getHours());
			date.setMinutes(time.getMinutes());
			date.setSeconds(0);

			let formatted = format(date, 'MM/DD/YYYY hh:mm:ss A');

			await this.setStateAsync({ incidentDt: formatted.toString() });

			const res = await axios.post(`${config.baseApiUrl}/Form`, this.state);

			if (res.status !== 201) {
				this.setState({
					formError: true,
					errorHeader: 'Captcha',
					errorContent: `Error: There was a problem validating the captcha response, please try again.`
				});
			} else {
				this.setState(this.initialState);

				this.setState({
					formSuccess: true,
					successHeader: 'Thank You For Your Submission',
					successContent:
						'Your Request for a Digital Video Recording has been received. You will receive an email with details on next steps.'
				});
			}
		} catch (e) {
			this.setState({
				formError: true,
				errorHeader: 'Error',
				errorContent: 'There was a problem submitting your video request form.'
			});
		}

		window.scrollTo(0, 0);
		this.captcha.reset();
		this.setState({ loading: false });
	};

	handleDismiss = () => {
		this.setState({ formSuccess: false });
	};

	renderCascadingFields() {
		switch (this.state.vehicleType) {
			case 'LRV':
				return (
					<>
						<Form.Group widths="equal">
							<Form.Dropdown
								label="Direction"
								id="direction"
								placeholder="Select a Direction"
								selection
								options={dropdownOptions.directionOptions}
								onChange={(e, { value }) => this.setState({ direction: value })}
								value={this.state.direction}
							/>
							<Form.Field>
								<label>Location</label>
								<Dropdown
									placeholder="Select a Metrolink Station"
									search
									selection
									options={dropdownOptions.metrolinkStations}
									onChange={(e, { value }) =>
										this.setState({ busLocation: value })
									}
									value={this.state.busLocation}
								/>
							</Form.Field>
						</Form.Group>
						<Form.Group widths="equal">
							<Form.Field>
								<label>LRV Car</label>
								<Dropdown
									placeholder="Which LRV Car?"
									selection
									options={dropdownOptions.LRVTypeOptions}
									onChange={(e, { value }) => this.setState({ lrvCar: value })}
									value={this.state.lrvCar}
								/>
							</Form.Field>
							<Form.Field>
								<label>Specific Location</label>
								<Dropdown
									placeholder="Select a Specific Location"
									selection
									options={dropdownOptions.LRVSpecificLocationOptions}
									onChange={(e, { value }) =>
										this.setState({ lrvLocation: value })
									}
									value={this.state.lrvLocation}
								/>
							</Form.Field>
						</Form.Group>
					</>
				);

			case 'N/A':
				const NAlocations = dropdownOptions.NALocations.concat(
					dropdownOptions.metrolinkStations
				).sort();

				return (
					<>
						<Form.Group widths="equal">
							<Form.Dropdown
								label="Direction"
								id="direction"
								placeholder="Select a Direction"
								selection
								options={dropdownOptions.directionOptions}
								onChange={(e, { value }) => this.setState({ direction: value })}
								value={this.state.direction}
							/>
							<Form.Field>
								<label>Location</label>
								<Dropdown
									placeholder="Select a Location"
									search
									selection
									options={NAlocations}
									onChange={(e, { value }) =>
										this.setState({ busLocation: value })
									}
									value={this.state.busLocation}
								/>
							</Form.Field>
						</Form.Group>
					</>
				);

			default:
				return (
					<>
						<Form.Group widths="equal">
							<Form.Dropdown
								label="Direction"
								id="direction"
								placeholder="Select a Direction"
								selection
								options={dropdownOptions.directionOptions}
								onChange={(e, { value }) => this.setState({ direction: value })}
								value={this.state.direction}
							/>
							<Form.Field
								label="Location"
								control="input"
								maxLength="50"
								onChange={(e) => this.setState({ busLocation: e.target.value })}
								value={this.state.busLocation}
							/>
						</Form.Group>
					</>
				);
		}
	}

	handleChange = (value) => {
		this.setState({ reCaptchaResponse: value });
	};

	handleHelpClick = (e) => {
		e.preventDefault();
	};

	render() {
		const { loading } = this.state;

		return (
			<Form
				onSubmit={this.handleSubmit}
				error={this.state.formError}
				success={this.state.formSuccess}
			>
				<Dimmer.Dimmable dimmed={loading}>
					<Dimmer active={loading} page inverted>
						<Loader>Loading</Loader>
					</Dimmer>
					<Container textAlign="left">
						<Message
							error
							header={this.state.errorHeader}
							content={this.state.errorContent}
						/>
						<Message
							success
							header={this.state.successHeader}
							content={this.state.successContent}
							onDismiss={this.handleDismiss}
						/>
						<Form.Group widths="equal">
							<Form.Dropdown
								label="Vehicle Type"
								id="vehicleType"
								placeholder="Select Vehicle Type"
								selection
								options={dropdownOptions.vehicleTypeOptions}
								onChange={(e, { value }) =>
									this.setState({ vehicleType: value })
								}
								value={this.state.vehicleType}
							/>
							<Form.Field
								label="Vehicle Number"
								control={Input}
								action={
									<Modal
										closeIcon
										trigger={
											<Button
												icon="help"
												color="blue"
												onClick={this.handleHelpClick}
											/>
										}
									>
										<Modal.Header>Vehicle Number Locations</Modal.Header>
										<Modal.Content image>
											<Image src={VehicleNumberLocation} />
										</Modal.Content>
									</Modal>
								}
								maxLength="50"
								onChange={(e) =>
									this.setState({ vehicleNumber: e.target.value })
								}
								value={this.state.vehicleNumber}
							/>
						</Form.Group>
						{this.renderCascadingFields()}
						<Form.Group widths="equal">
							<Form.Input
								label="Crime/Incident Classification"
								id="incidentClassification"
								maxLength="50"
								required
								onChange={(e) =>
									this.setState({ incidentClassification: e.target.value })
								}
								value={this.state.incidentClassification}
							/>
							<Form.Input
								required
								label="Case Number"
								id="caseNumber"
								maxLength="50"
								onChange={(e) => this.setState({ caseNum: e.target.value })}
								value={this.state.caseNum}
							/>
						</Form.Group>
						<Form.Group>
							{/* <Form.Group> */}
							<Form.Field required width={4}>
								<label>Date of Incident</label>
								<DatePicker
									onChange={(e) =>
										this.setState({ incidentDt: e.target.value })
									}
									defaultValue={this.state.incidentDt}
									// value={this.state.incidentDt}
								/>
							</Form.Field>
							<Form.Field required width={4}>
								<label>Time of Incident</label>
								<TimePicker
									steps={{ minute: 15 }}
									format="hh:mm a"
									onChange={(e) =>
										this.setState({ incidentTime: e.target.value })
									}
									defaultValue={this.state.incidentTime}
									// value={this.state.incidentTime}
								/>
							</Form.Field>
							{/* </Form.Group> */}
							<Form.TextArea
								width={8}
								label="Suspect/Witness Description"
								id="susWitDescription"
								rows="3"
								maxLength="250"
								onChange={(e) => this.setState({ suspectDesc: e.target.value })}
								value={this.state.suspectDesc}
							/>
						</Form.Group>
						<Form.TextArea
							label="Synopsis"
							id="synopsis"
							rows="3"
							maxLength="500"
							onChange={(e) => this.setState({ synopsis: e.target.value })}
							value={this.state.synopsis}
						/>
						<Form.Group widths="equal">
							<Form.Dropdown
								required
								label="Media Type"
								id="mediaType"
								placeholder="Select a Media Type"
								selection
								options={[
									{ key: 'DVD', value: 'DVD', text: 'DVD' },
									{
										key: 'StillPhoto',
										value: 'Still Photo',
										text: 'Still Photo'
									}
								]}
								onChange={(e, { value }) => this.setState({ mediaType: value })}
								value={this.state.mediaType}
							/>
							<Form.Dropdown
								required
								label="Media Quantity"
								id="mediaQuantity"
								placeholder="Select a Media Type"
								selection
								compact
								options={[
									{ key: 1, value: 1, text: '1' },
									{ key: 2, value: 2, text: '2' }
								]}
								onChange={(e, { value }) =>
									this.setState({ mediaQuantity: value })
								}
								value={this.state.mediaQuantity}
							/>
						</Form.Group>
						<Form.Group widths="equal">
							<Form.Input
								label="Agency Name"
								id="agencyName"
								required
								onChange={(e) => this.setState({ agencyName: e.target.value })}
								value={this.state.agencyName}
							/>
							<Form.Input
								label="Officer Name"
								id="officerName"
								maxLength="50"
								required
								onChange={(e) => this.setState({ officerName: e.target.value })}
								value={this.state.officerName}
							/>
							<Form.Input
								label="Officer DSN"
								id="officerDSN"
								maxLength="50"
								required
								onChange={(e) => this.setState({ officerDSN: e.target.value })}
								value={this.state.officerDSN}
							/>
						</Form.Group>
						<Form.Group widths="equal">
							<Form.Input
								label="Contact Email"
								id="contactEmail"
								maxLength="50"
								required
								type="email"
								onChange={(e) =>
									this.setState({ contactEmail: e.target.value })
								}
								value={this.state.contactEmail}
							/>
							<Form.Input
								label="Contact Phone"
								id="contactPhone"
								maxLength="50"
								required
								type="tel"
								onChange={(e) =>
									this.setState({ contactPhone: e.target.value })
								}
								value={this.state.contactPhone}
							/>
						</Form.Group>
					</Container>
					<Form.Group>
						<Container textAlign="center">
							<Form.Field required>
								<Checkbox
									id="noticeAccepted"
									onClick={() =>
										this.setState({
											noticeAccepted: !this.state.noticeAccepted
										})
									}
									label={
										<label htmlFor="noticeAccepted">
											I have read the{' '}
											<span
												style={{ textDecoration: 'underline' }}
												onClick={() => this.setState({ showModal: true })}
											>
												Confidentiality Notice
											</span>
										</label>
									}
									checked={this.state.noticeAccepted}
								/>
								<Modal open={this.state.showModal}>
									<Modal.Header>Confidentiality Notice</Modal.Header>
									<Modal.Content>
										<Modal.Description>
											<Container text textAlign="justified">
												<p>
													This transmission may contain confidential or
													privileged information, intended only for use by the
													individual or entity to which the transmission is
													addressed. If you are not the intended recipient, you
													are hereby notified that any disclosure,
													dissemination, copying or distribution of this
													transmission is strictly prohibited. If you received
													this communication in error, please notify our
													division immediately by replying to this message and
													delete the transmission from your computer. Please
													treat this and all other documents from&nbsp;
													<strong>
														Metro Transit Authority, Bi-State Development Agency
													</strong>
													&nbsp;as&nbsp;
													<strong>
														SENSITIVE MATERIAL / FOR OFFICIAL USE ONLY
													</strong>
													. Further distribution of this document is restricted
													to law enforcement agencies, intelligence agencies and
													Department of Justice organizations only, unless prior
													approval of&nbsp;
													<strong>
														Metro Transit Authority, Bi-State Development Agency
													</strong>
													&nbsp;has been obtained. Keep in mind that this
													document, or any segment thereof, may not be released
													to any media sources. Do not disseminate, which
													includes forwarding the contents of this message,
													without the approval of the sender.
												</p>
											</Container>
										</Modal.Description>
									</Modal.Content>
									<Modal.Actions>
										<Button
											color="blue"
											onClick={() => {
												this.setState({ showModal: false });
											}}
										>
											Ok
										</Button>
									</Modal.Actions>
								</Modal>
							</Form.Field>
						</Container>
					</Form.Group>
					<Form.Group>
						<Container textAlign="center">
							<ReCAPTCHA
								ref={(el) => {
									this.captcha = el;
								}}
								style={{ display: 'inline-block' }}
								size="normal"
								sitekey={config.reCaptchaSiteKey}
								onChange={this.handleChange}
							/>
						</Container>
					</Form.Group>
					<Form.Group>
						<Container textAlign="center">
							<Form.Field>
								<Button type="submit" size="large" color="twitter">
									Submit
								</Button>
							</Form.Field>
						</Container>
					</Form.Group>
				</Dimmer.Dimmable>
			</Form>
		);
	}
}

export default VRPForm;
